<template>
  <div>
    <v-btn text color="blue" @click="getDoc">
      <slot>Save</slot>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { createAndSaveDocument } from "@/utils/docx-util";

// Props
interface Props {
  filePath: string;
  fileName: string;
  dataSet: any;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (event: "success"): void;
  (event: "error", error: unknown): void;
}>();

// Method
const getDoc = async () => {
  try {
    await createAndSaveDocument(props.fileName, props.filePath, props.dataSet);
    emit("success");
  } catch (error) {
    emit("error", error);
  }
};

// If you need to expose methods to parent component
defineExpose({
  getDoc,
});
</script>
